import React, { Component } from "react";
import "../../style/common/footBar.scss";
import footer_logo from "../../image/news-logo.svg";
import Facebook from "../../icon/Facebook";
import Instagram from "../../icon/Instagram";
import Youtube from "../../icon/Youtube";
import X from "../../icon/X";
import Flipboard from "../../icon/Flipboard";
import Linkedin from "../../icon/Linkedin";
import Slack from "../../icon/Slack";
import Rss from "../../icon/Rss";
import Email from "../../icon/Email";
import Spotify from "../../icon/Spotify";
import iheartradio from "../../image/iheartradio.svg";
import Douyin from "../../icon/Douyin";
import BBC from "../../image/BBC.jpg";
import { lang } from "../../utils/lang";

class FootBar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <div className="text-center border p-10 pb-16 space-y-2 text-xs">
          <li>Tesla © 2024</li>
          <li>Privacy & Legal</li>
          <li>News</li>
        </div>
      </React.Fragment>
    );
  }
}

export default FootBar;
